import styled from 'styled-components';

import { COLOR_GRAY_30 } from 'styles/variables/colors';

export const Container = styled.div`
  background: white;
  border: 1px solid ${COLOR_GRAY_30};
  border-radius: 4px;
  padding: 40px;
`;
